export const getStaticRatingPercent = (
  productCode: string | number
): number => {
  const str = String(productCode);

  let hash = 2166136261;

  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }

  const percent = 80 + (Math.abs(hash) % 19);
  return percent;
};
